<template>
  <div class="page-mask" v-if="isUserNameShow">
    <div class="pc-set-user-name" :class="{ wap: isMobile == 1 }">
      <div class="header">
        <button class="close" @click="hideUserNameDialog"></button>
        <h2>请输入临时用户名</h2>
      </div>
      <div class="set-content">
        <input
          type="text"
          class="txt-name"
          v-model="userInfo.temporaryUserName"
          placeholder="请输入用户名"
        />
        <button type="button" class="btn-confirm" @click="setUserName">
          确定
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { $subscriber, ck, interact } from "fire-wind-water";
import { socketModule } from "../../common/socket";
import URL from "../../assets/conf/setting.json";
import user from "../../common/user";

export default {
  name: "userName",
  data() {
    return {
      isUserNameShow: false,
      userInfo: {},
      webinarInfo: {},
      isMobile: interact.isMobile
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      $subscriber.subscribe("userInfo", data => {
        this.userInfo = data;
      });
      $subscriber.subscribe("webinarInfo", data => {
        this.webinarInfo = data;
      });
      $subscriber.subscribe("showSetUserName", data => {
        this.isUserNameShow = data;
      });
    },
    hideUserNameDialog() {
      this.isUserNameShow = false;
    },
    setUserName() {
      if (this.userInfo.temporaryUserName.trim() == "") {
        $subscriber.emit("showPopup", { message: "请设置用户名" });
      } else {
        ck.cookie(
          "temporaryUserName_" + this.webinarInfo.webinarId,
          this.userInfo.temporaryUserName,
          { expires: 1, domain: window.$sk.config.domain, path: "/" }
        );
        let userInfo = this.userInfo;
        userInfo.name = ck.cookie(
          "temporaryUserName_" + this.webinarInfo.webinarId
        );
        socketModule.onSetUserInfo(userInfo);
        this.isUserNameShow = false;
      }
    }
  }
};
</script>

<style scoped></style>
